import tryGetRecipientsFromViewState from '../utils/tryGetRecipientsFromViewState';
import pauseSession from 'owa-controls-findpeople-feedback-manager/lib/actions/pauseSession';
import resumeSession from 'owa-controls-findpeople-feedback-manager/lib/actions/resumeSession';
import getAndPopulateSuggestedContacts from 'owa-recipient-cache/lib/actions/getAndPopulateSuggestedContacts';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import addLocalCacheTransactionComplete from 'owa-recipient-common/lib/utils/addLocalCacheTransactionComplete';
import getPersonasFromReadWriteRecipientList from 'owa-recipient-common/lib/utils/getPersonasFromReadWriteRecipientList';
import { action } from 'satcheljs/lib/legacy';

export default action('showHideFindResult')(function showHideFindResult(
    recipientWell: FindControlViewState | RecipientWellWithFindControlViewState,
    shouldShowFindResult: boolean,
    shouldClearFindResult?: boolean,
    recipientsToExclude?: ReadWriteRecipientViewState[]
) {
    let findResultCount = recipientWell.findResultSet ? recipientWell.findResultSet.length : 0;
    recipientWell.findResultHightlightIndex = -1;

    if (shouldClearFindResult && findResultCount) {
        // Clear existing find result if are not explicitly preserving the result.
        recipientWell.findResultSet.splice(0, findResultCount);
    }

    if (shouldShowFindResult) {
        resumeSession(recipientWell.findPeopleFeedbackManager);
        if (recipientWell.queryString.length == 0 && !recipientWell.inForceResolve) {
            // With no query string, get our suggested contacts list.
            let recipients = tryGetRecipientsFromViewState(recipientWell, recipientsToExclude);
            getAndPopulateSuggestedContacts(
                recipientWell.findResultSet,
                getPersonasFromReadWriteRecipientList(recipients)
            );
            addLocalCacheTransactionComplete(recipientWell);
        } else {
            // If we have (non suggested contacts) results, highlight the first (or the search box if no results).
            recipientWell.findResultHightlightIndex = 0;
        }
    } else {
        pauseSession(recipientWell.findPeopleFeedbackManager);
    }

    recipientWell.shouldShowFindResult = shouldShowFindResult;
});
